<template>
  <div class="signInWindow">
    <el-dialog
      :title="$t('main.sign_in_sign_up')"
      :visible="ifShow"
      :modal-append-to-body="false"
      @open="openDialog"
      @close="closeDialog"
      center
    >
      <!--  -->
      <div
        v-if="!showEmailLoginDialog"
        data-v-14fe14fc=""
        id="firebaseui-auth-container"
        lang="en"
        v-loading="dialogLoading"
      >
        <div
          class="firebaseui-container firebaseui-page-provider-sign-in firebaseui-id-page-provider-sign-in firebaseui-use-spinner"
        >
          <div class="firebaseui-card-content">
            <form onsubmit="return false;">
              <ul class="firebaseui-idp-list">
                <li class="firebaseui-list-item">
                  <button
                    class="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised firebaseui-idp-google firebaseui-id-idp-button"
                    data-provider-id="google.com"
                    style="background-color: #ffffff"
                    data-upgraded=",MaterialButton"
                    @click="() => signInWith('google.com')"
                  >
                    <span class="firebaseui-idp-icon-wrapper"
                      ><img
                        class="firebaseui-idp-icon"
                        alt=""
                        src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" /></span
                    ><span class="firebaseui-idp-text firebaseui-idp-text-long"
                      >Sign in with Google</span
                    ><span class="firebaseui-idp-text firebaseui-idp-text-short"
                      >Google</span
                    >
                  </button>
                </li>
                <li class="firebaseui-list-item">
                  <button
                    class="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised firebaseui-idp-facebook firebaseui-id-idp-button"
                    data-provider-id="facebook.com"
                    style="background-color: #3b5998"
                    data-upgraded=",MaterialButton"
                    @click="() => signInWith('facebook.com')"
                  >
                    <span class="firebaseui-idp-icon-wrapper"
                      ><img
                        class="firebaseui-idp-icon"
                        alt=""
                        src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/facebook.svg" /></span
                    ><span class="firebaseui-idp-text firebaseui-idp-text-long"
                      >Sign in with Facebook</span
                    ><span class="firebaseui-idp-text firebaseui-idp-text-short"
                      >Facebook</span
                    >
                  </button>
                </li>
                <li class="firebaseui-list-item">
                  <button
                    class="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised firebaseui-idp-password firebaseui-id-idp-button"
                    data-provider-id="password"
                    style="background-color: #db4437"
                    data-upgraded=",MaterialButton"
                    @click="showEmailLoginDialog = true"
                  >
                    <span class="firebaseui-idp-icon-wrapper"
                      ><img
                        class="firebaseui-idp-icon"
                        alt=""
                        src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/mail.svg" /></span
                    ><span class="firebaseui-idp-text firebaseui-idp-text-long"
                      >Sign in with email</span
                    ><span class="firebaseui-idp-text firebaseui-idp-text-short"
                      >Email</span
                    >
                  </button>
                </li>
                <li class="firebaseui-list-item">
                  <button
                    class="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised firebaseui-idp-generic firebaseui-id-idp-button"
                    data-provider-id="apple.com"
                    style="background-color: #000000"
                    data-upgraded=",MaterialButton"
                    @click="() => signInWith('apple.com')"
                  >
                    <span class="firebaseui-idp-icon-wrapper"
                      ><img
                        class="firebaseui-idp-icon"
                        alt=""
                        src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/apple.png" /></span
                    ><span class="firebaseui-idp-text firebaseui-idp-text-long"
                      >Sign in with Apple</span
                    ><span class="firebaseui-idp-text firebaseui-idp-text-short"
                      >Apple</span
                    >
                  </button>
                </li>
              </ul>
            </form>
          </div>
          <div
            class="firebaseui-card-footer firebaseui-provider-sign-in-footer"
          >
            <p class="firebaseui-tos firebaseui-tospp-full-message">
              By continuing, you are indicating that you accept our
              <a
                href="https://www.speakey.com/terms-conditions.html"
                class="firebaseui-link firebaseui-tos-link"
                target="_blank"
                >Terms of Service</a
              >
              and
              <a
                href="https://www.speakey.com/privacy-policy.html"
                class="firebaseui-link firebaseui-pp-link"
                target="_blank"
                >Privacy Policy</a
              >.
            </p>
          </div>
        </div>
      </div>
      <el-form
        v-if="showEmailLoginDialog"
        :model="emailForm"
        ref="loginForm"
        :rules="rules"
        v-loading="dialogLoading"
      >
        <el-form-item label="Email" prop="email">
          <el-input
            v-model="emailForm.email"
            :disabled="showPassword"
            placeholder="Enter your email"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          v-if="showPassword & displayName"
          label="First & last name"
          prop="name"
        >
          <el-input
            v-model="emailForm.name"
            placeholder="Enter your password"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item v-if="showPassword" label="Password" prop="password">
          <el-input
            v-model="emailForm.password"
            placeholder="Enter your password"
            show-password
            autocomplete="off"
          />
        </el-form-item>
      </el-form>
      <!-- 登录注册 -->
      <div
        v-if="showEmailLoginDialog && showPassword"
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="btnBack">Back</el-button>
        <el-button v-if="!verifyEmail" type="primary" @click="signInWithEmail"
          >Sign In / Sign Up</el-button
        >
        <el-button v-if="verifyEmail" type="primary" @click="checkEmailVerified"
          >I’ve verified my email</el-button
        >
      </div>
      <!-- 下一步 -->
      <div
        v-if="showEmailLoginDialog && !showPassword"
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="reset">Back</el-button>
        <el-button type="primary" @click="nextPassword">Next</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchSignInMethodsForEmail,
  linkWithCredential,
  signOut,
  updateProfile,
  EmailAuthProvider,
} from "firebase/auth";
import "firebaseui/dist/firebaseui.css";
import { getUserToken } from "@/api/auth";
import { setToken } from "@/utils/authUtil";
import {
  loginWithGoogle,
  loginWithPassword,
  loginWithFacebook,
  loginWithApple,
  linkWithGoogle,
  linkWithFacebook,
  linkWithApple,
  linkWithPassword,
  sendVerifyEmail,
} from "@/utils/firebae-login";
const loginMethods = {
  "google.com": loginWithGoogle,
  "facebook.com": loginWithFacebook,
  "apple.com": loginWithApple,
  password: loginWithPassword,
};
const linkMethods = {
  "google.com": linkWithGoogle,
  "facebook.com": linkWithFacebook,
  "apple.com": linkWithApple,
  password: linkWithPassword,
};
export default {
  data() {
    return {
      dialogLoading: false,
      uiLoad: false,
      showEmailLoginDialog: false,
      showPassword: false,
      displayName: false,
      pendingCred: null,
      verifyEmail: false,
      isLoggingIn: false,
      emailForm: {
        email: "",
        password: "",
      },
      rules: {
        email: [
          { required: true, message: "Email is required", trigger: "blur" },
          {
            type: "email",
            message: "Please enter a valid email address",
            trigger: ["blur", "change"],
          },
        ],
        password: [
          { required: true, message: "Password is required", trigger: "blur" },
          {
            min: 6,
            message: "Password must be at least 6 characters",
            trigger: "blur",
          },
        ],
      },
    };
  },
  props: ["ifShow"],
  mounted() {
    // this.toLink("password", "");
  },
  watch: {
    // isLoggingIn(newVal, oldVal) {
    //   if (newVal) {
    //     console.time();
    //     this.dialogLoading = true;
    //   } else {
    //     console.timeEnd();
    //     this.dialogLoading = false;
    //   }
    //   console.log("message changed from", oldVal, "to", newVal);
    // },
  },
  beforeDestroy() {},
  methods: {
    openDialog() {
      // this.toLink("password", {});
    },
    btnBack() {
      this.showEmailLoginDialog = false;
      this.showPassword = false;
      this.displayName = false;
      this.verifyEmail = false;
      signOut(this.auth);
    },
    reset() {
      this.dialogLoading = false;
      this.uiLoad = false;
      this.showEmailLoginDialog = false;
      this.showPassword = false;
      this.displayName = false;
      this.pendingCred = null;
      this.emailForm = {
        email: "",
        password: "",
        name: "",
      };
    },
    async checkEmailVerified() {
      const user = auth.currentUser;
      await user.reload(); // 👈 必须刷新
      if (user.emailVerified) {
        // ✅ 验证成功
        this.checkToken(user);
      } else {
        // ❌ 尚未验证
        this.$message.error(
          "We couldn’t verify your email address. Please ensure you’ve completed the verification and try again."
        );
      }
    },
    async nextPassword() {
      this.$refs.loginForm.validateField("email", async (errorMessage) => {
        const methods = await fetchSignInMethodsForEmail(
          this.auth,
          this.emailForm.email
        );
        this.displayName = !methods.length;
        if (!errorMessage) {
          this.showPassword = true;
        } else {
          this.showPassword = false;
        }
      });
    },
    /**
     * 关闭登录对话框
     */
    errorDialog(error) {
      const err = JSON.stringify(error);
      this.$message.error("Something is wrong, please try again later.");
      this.reset();
      this.$emit("update:ifShow", false);
      this.trackEvent("web_error", {
        type: "sign_in_error",
        message: err,
      });
    },
    closeDialog() {
      this.$emit("update:ifShow", false);
      this.reset();
    },
    checkToken(user) {
      const that = this;
      this.dialogLoading = true;
      getUserToken({ user })
        .then((token) => {
          setToken(token);
          that.$emit("update:ifShow", false);
          that.reset();
          location.reload();
        })
        .catch((error) => {
          that.errorDialog(error);
          that.reset();
        });
    },

    async signInWith(providerName) {
      // 防止重复点击
      // if (this.isLoggingIn) return;
      // this.isLoggingIn = true;
      this.pendingCred = null;

      let methods = null;
      const { data, error, errorInfo } = await loginMethods[providerName]();
      this.isLoggingIn = false;
      // 成功
      if (data) {
        this.checkToken(data.user);
      }
      // 错误处理
      if (errorInfo || error) {
        console.log("错误", errorInfo);
        // 多开登录弹窗和用户关闭弹窗不处理
        if (
          errorInfo.code === "auth/popup-closed-by-user" ||
          errorInfo.code === "auth/cancelled-popup-request"
        ) {
          return;
        }
        // 有email的时候监听当前邮箱包含的登录形式
        if (errorInfo.email) {
          try {
            methods = await fetchSignInMethodsForEmail(
              this.auth,
              errorInfo.email
            );
          } catch (err) {
            console.log(err);
          }
        }

        // 埋点
        this.trackEvent("web_error", {
          type: "sign_in_error_" + errorInfo?.code || JSON.stringify(error),
          message: errorInfo?.message || JSON.stringify(error),
        });
        // 合并账号
        if (
          errorInfo?.code === "auth/account-exists-with-different-credential"
        ) {
          if (!methods.length) {
            this.$message.error("Something is wrong, please try again later.");
            this.reset();
            return;
          }

          if (methods.includes("google.com") && providerName !== "google.com") {
            this.toLink("google.com", errorInfo);
          } else if (
            methods.includes("facebook.com") &&
            providerName !== "facebook.com"
          ) {
            this.toLink("facebook.com", errorInfo);
          } else if (
            methods.includes("apple.com") &&
            providerName !== "apple.com"
          ) {
            this.toLink("apple.com", errorInfo);
          } else if (methods.includes("password")) {
            this.toLink("password", errorInfo);
          }
        }
        // 其他错误提示，并关闭
        // this.$message.error(errorInfo.message);
        this.reset();
      }
    },
    async toLink(providerId, errorInfo, noLink) {
      const info = {
        "google.com": "Google",
        "facebook.com": "Facebook",
        "apple.com": "Apple",
        password: "Email",
      };
      let str = info[providerId];
      const that = this;

      this.$alert(
        `<div class="alert-content">
          <p class="bold-text" style='margin-bottom:10px; font-size:18px;'>You already have an account</p>
          <p>
            You've already used
            <strong style="font-size:16px;">${errorInfo.email ?? ""}</strong>.
            Sign in with ${str} to continue.
          </p>
      </div>`,
        "Sign in",
        {
          center: false,
          confirmButtonText: "SIGN IN WITH " + str.toLocaleUpperCase(),
          dangerouslyUseHTMLString: true,
          customClass: "my-custom-alert",
          callback: async (action) => {
            if (action === "cancel") {
              that.dialogLoading = false;
              return;
            }
            if (providerId === "password") {
              that.showEmailLoginDialog = true;
              that.emailForm.email = errorInfo.email;
              that.displayName = false;
              that.pendingCred = errorInfo.credential;
              return;
            }
            const { data } = await loginMethods[providerId](errorInfo.email);
            if (data) {
              if (data.user.email === errorInfo.email && !noLink) {
                try {
                  await linkWithCredential(data.user, errorInfo.credential);
                } catch (err) {
                  console.error("Failed to link credential:", err);
                  // 可选：给用户提示或做兜底处理
                }
              }
              that.checkToken(data.user);
            }
          },
        }
      );
    },
    async signInWithEmail() {
      // 防止重复点击
      if (this.isLoggingIn) return;
      this.isLoggingIn = true;
      const that = this;
      const auth = this.auth;
      const email = this.emailForm.email;
      const password = this.emailForm.password;

      const pendingCred = this.pendingCred;
      // 调取登录
      const { data, errorInfo } = await loginWithPassword(email, password);
      // 防抖

      // 成功回调
      if (data) {
        const user = data.user;
        await user.reload?.();
        console.log("emailVerified", user.emailVerified);
        // 邮箱验证
        if (!user.emailVerified) {
          const { errorInfo } = await sendVerifyEmail(data.user);
          if (errorInfo) {
            if (errorInfo.code === "auth/too-many-requests") {
              // that.$message.error("Too many requests. Please try again later.");
            }
            console.log(errorInfo);
          }

          that.$message.success(
            "We've sent a verification email. Please open your inbox and verify your email address."
          );
          // this.verifyEmail = true;
        }
        // 更新昵称
        if (that.displayName) {
          try {
            await updateProfile(user, {
              displayName: that.emailForm.name,
            });
          } catch (err) {
            console.error("updateProfile error", err);
          }
        }

        if (pendingCred) {
          try {
            await linkWithCredential(data.user, pendingCred);
          } catch (err) {
            console.error("Failed to link credential:", err);
          }
          this.pendingCred = null;
        }

        this.checkToken(data.user);
      }

      // 失败
      if (errorInfo) {
        console.log("错误", errorInfo);
        errorInfo.email = email;
        const methods = await fetchSignInMethodsForEmail(auth, email);
        errorInfo.credential = EmailAuthProvider.credential(email, password);
        // 密码格式错误
        if (errorInfo.code === "auth/weak-password") {
          that.$message.error(
            "Your password must be at least 6 characters long."
          );
        }
        // 密码错误
        else if (errorInfo.code === "auth/wrong-password") {
          that.$message.error("Incorrect password. Please try again.");
        }
        // 已存在其他登录方式，进行绑定
        else if (errorInfo.code === "auth/email-already-in-use") {
          if (methods.includes("google.com")) {
            this.toLink("google.com", errorInfo);
          } else if (methods.includes("facebook.com")) {
            this.toLink("facebook.com", errorInfo);
          } else if (methods.includes("apple.com")) {
            this.toLink("apple.com", errorInfo);
          }
        }
      }
      this.isLoggingIn = false;
      this.pendingCred = null;
    },
  },
};
</script>
<style>
.el-message-box__wrapper::after {
  height: 0 !important;
}

.el-message-box__wrapper > .el-message-box {
  margin-top: 15vh;
  max-width: 410px;
}

.my-custom-alert {
  color: black;
  padding: 15px 5px;
  /* height: 402px; */
}
.my-custom-alert .alert-content {
  color: black;
}
.my-custom-alert .bold-text {
  font-weight: bold;
  color: black;
}
</style>
<style lang="scss" scoped>
.signInWindow {
  ::v-deep .el-dialog {
    max-width: 410px;
  }
  ::v-deep .v-modal {
    opacity: 0.92;
  }
}

@media screen and (max-width: 768px) {
  .signInWindow {
    ::v-deep .el-dialog {
      width: 92%;
    }
  }
}
</style>
